import { useState } from 'react'
import { Link } from 'react-router-dom'

export default function Login() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleGoogleLogin = async () => {
    setLoading(true)
    setError(null)
    try {
      const res = await fetch('/api/auth/google/url')
      const json = await res.json()
      if (json.authUrl) window.location.href = json.authUrl
      else setError('Connexion impossible. Contactez votre administrateur.')
    } catch {
      setError('Connexion impossible. Contactez votre administrateur.')
      setLoading(false)
    }
  }

  return (
    <div className="grid h-screen w-screen max-[900px]:grid-cols-[1fr]" style={{ gridTemplateColumns: 'minmax(520px, 46%) 1fr' }}>

      {/* ═══ LEFT PANEL ═══ */}
      <aside className="relative overflow-hidden flex flex-col max-[900px]:px-8 max-[900px]:py-8" style={{ background: '#060812', padding: '44px 64px', fontFamily: "'Geist', system-ui, -apple-system, sans-serif" }}>
        {/* Radial gradient overlays */}
        <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(ellipse 600px 400px at 20% 0%, rgba(61,72,196,0.14), transparent 60%), radial-gradient(ellipse 500px 500px at 100% 100%, rgba(24,207,212,0.06), transparent 60%)',
        }} />

        <div className="relative z-10 flex-1 flex flex-col">
          {/* Form area — vertically centered */}
          <div className="flex-1 flex items-center" style={{ maxWidth: 440 }}>
            <form className="w-full" onSubmit={e => e.preventDefault()}>
              {/* Logo */}
              <div className="mb-7">
                <img
                  src="/logo-orion.png"
                  alt="Orion"
                  className="block"
                  style={{ width: 200, height: 'auto', filter: 'invert(1) hue-rotate(180deg) brightness(1.15) saturate(1.1)' }}
                />
              </div>

              {/* Heading */}
              <h1 style={{ fontFamily: "'Geist', sans-serif", fontWeight: 700, fontSize: 38, lineHeight: 1.08, letterSpacing: '-0.035em', color: '#eaeefb', margin: '0 0 14px' }}>
                Bienvenue.
              </h1>

              {/* Subtitle */}
              <p style={{ fontSize: 15, color: '#8a92ab', margin: '0 0 36px', maxWidth: 360, lineHeight: 1.5 }}>
                <strong style={{ color: '#eaeefb', fontWeight: 500 }}>Plateforme d'analyse SEO</strong> by{' '}
                <img src="/elorion-logo-dark.png" alt="Elorion" style={{ height: 22, width: 'auto', verticalAlign: '-0.18em', margin: '0 2px 0 4px', display: 'inline' }} />.
                <br />
                Connectez-vous pour acc&eacute;der &agrave; vos outils.
              </p>

              {/* Google button */}
              <button
                type="button"
                onClick={handleGoogleLogin}
                disabled={loading}
                className="w-full flex items-center justify-center gap-3 border-none cursor-pointer disabled:opacity-60 disabled:cursor-wait"
                style={{
                  background: '#ffffff',
                  color: '#1f1f1f',
                  borderRadius: 10,
                  padding: '15px 18px',
                  fontFamily: "'Geist', sans-serif",
                  fontSize: 15,
                  fontWeight: 600,
                  boxShadow: '0 2px 12px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.05)',
                  transition: 'all 150ms ease-out',
                }}
                onMouseEnter={e => {
                  if (!loading) {
                    e.currentTarget.style.transform = 'translateY(-1px)'
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(24,207,212,0.22), 0 0 0 1px rgba(24,207,212,0.4)'
                  }
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.05)'
                }}
                onMouseDown={e => { e.currentTarget.style.transform = 'translateY(0) scale(0.99)' }}
                onMouseUp={e => { e.currentTarget.style.transform = 'translateY(-1px)' }}
              >
                {loading ? (
                  <div className="w-5 h-5 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
                ) : (
                  <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
                    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
                    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
                    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
                    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
                  </svg>
                )}
                {loading ? 'Connexion...' : 'Continuer avec Google'}
              </button>

              {/* Error message */}
              {error && (
                <p style={{ fontSize: 13, color: '#EF4444', marginTop: 12 }}>{error}</p>
              )}

              {/* Access note */}
              <div className="flex items-center gap-2" style={{ marginTop: 5, fontSize: 13, color: '#5b6280' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
                  <rect x="4" y="11" width="16" height="10" rx="2" />
                  <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                </svg>
                Acc&egrave;s r&eacute;serv&eacute; aux comptes autoris&eacute;s
              </div>
            </form>
          </div>

          {/* Footer */}
          <div className="flex justify-between items-center" style={{ fontSize: 12, color: '#5b6280', fontFamily: "'Geist Mono', monospace", letterSpacing: '0.02em' }}>
            <span>Orion &middot; Elorion</span>
            <div className="flex gap-[22px]">
              <Link to="/legal/mentions" className="no-underline transition-colors duration-150 hover:!text-[#8a92ab]" style={{ color: '#5b6280' }}>
                Mentions l&eacute;gales
              </Link>
              <Link to="/legal/cgu" className="no-underline transition-colors duration-150 hover:!text-[#8a92ab]" style={{ color: '#5b6280' }}>
                CGU
              </Link>
              <Link to="/legal/confidentialite" className="no-underline transition-colors duration-150 hover:!text-[#8a92ab]" style={{ color: '#5b6280' }}>
                Confidentialit&eacute;
              </Link>
            </div>
          </div>
        </div>
      </aside>

      {/* ═══ RIGHT PANEL (cosmos) ═══ */}
      <section className="relative overflow-hidden max-[900px]:hidden" style={{ background: '#000' }}>
        {/* Nebula background */}
        <img
          src="/nebula.jpg"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
          loading="eager"
        />

        {/* Gradient overlay */}
        <div className="absolute inset-0 z-[1]" style={{
          background: 'linear-gradient(90deg, rgba(6,8,18,0.85) 0%, rgba(6,8,18,0.25) 25%, rgba(6,8,18,0) 55%), radial-gradient(ellipse 60% 60% at 70% 50%, rgba(0,0,0,0) 0%, rgba(6,8,18,0.3) 100%)',
        }} />

        {/* Constellation SVG */}
        <div className="absolute inset-0 z-[2] pointer-events-none">
          <svg viewBox="0 0 1000 1000" preserveAspectRatio="xMidYMid slice" className="w-full h-full">
            {/* Constellation lines */}
            <g stroke="rgba(255,255,255,0.35)" strokeWidth="1" fill="none" strokeDasharray="2 4">
              <line x1="320" y1="280" x2="560" y2="300" />
              <line x1="320" y1="280" x2="400" y2="500" />
              <line x1="560" y1="300" x2="540" y2="520" />
              <line x1="400" y1="500" x2="470" y2="510" />
              <line x1="470" y1="510" x2="540" y2="520" />
              <line x1="400" y1="500" x2="330" y2="720" />
              <line x1="540" y1="520" x2="620" y2="740" />
              <line x1="330" y1="720" x2="620" y2="740" />
              <line x1="320" y1="280" x2="420" y2="180" />
              <line x1="560" y1="300" x2="420" y2="180" />
            </g>

            {/* Main stars with glow */}
            <circle className="fill-white animate-twinkle" cx="320" cy="280" r="4" />
            <circle className="fill-white animate-twinkle" cx="320" cy="280" r="9" opacity="0.25" />
            <circle className="fill-white animate-twinkle-2" cx="560" cy="300" r="3.5" />
            <circle className="fill-white" cx="560" cy="300" r="7" opacity="0.22" />
            <circle className="fill-white animate-twinkle-3" cx="400" cy="500" r="3" />
            <circle className="fill-white animate-twinkle" cx="470" cy="510" r="3.5" />
            <circle className="fill-white animate-twinkle-2" cx="540" cy="520" r="3" />
            <circle className="fill-white animate-twinkle-3" cx="330" cy="720" r="3.5" />
            <circle className="fill-white animate-twinkle" cx="620" cy="740" r="4" />
            <circle className="fill-white animate-twinkle-2" cx="420" cy="180" r="2.5" />

            {/* Scattered background stars */}
            <g fill="#fff">
              <circle className="animate-twinkle" cx="120" cy="140" r="1" />
              <circle className="animate-twinkle-2" cx="220" cy="90" r="1.2" />
              <circle className="animate-twinkle-3" cx="780" cy="130" r="1.5" />
              <circle className="animate-twinkle" cx="880" cy="240" r="1" />
              <circle className="animate-twinkle-2" cx="160" cy="420" r="1.1" />
              <circle className="animate-twinkle-3" cx="90" cy="640" r="1.3" />
              <circle className="animate-twinkle" cx="850" cy="600" r="1.2" />
              <circle className="animate-twinkle-2" cx="720" cy="860" r="1" />
              <circle className="animate-twinkle-3" cx="250" cy="860" r="1.4" />
              <circle className="animate-twinkle" cx="500" cy="80" r="1.1" />
              <circle className="animate-twinkle-2" cx="640" cy="60" r="0.9" />
              <circle className="animate-twinkle-3" cx="760" cy="440" r="1" />
              <circle className="animate-twinkle" cx="190" cy="260" r="0.8" />
              <circle className="animate-twinkle-2" cx="920" cy="400" r="1.1" />
              <circle className="animate-twinkle-3" cx="60" cy="340" r="1" />
              <circle className="animate-twinkle" cx="440" cy="900" r="1.2" />
              <circle className="animate-twinkle-2" cx="680" cy="380" r="0.9" />
            </g>
          </svg>
        </div>

        {/* System status chip */}
        <div
          className="absolute top-8 right-9 z-[4] flex items-center gap-2.5"
          style={{
            fontFamily: "'Geist Mono', monospace",
            fontSize: 11,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            color: 'rgba(234,238,251,0.7)',
            padding: '8px 14px',
            background: 'rgba(6,8,18,0.35)',
            backdropFilter: 'blur(18px)',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: 999,
          }}
        >
          <span
            className="animate-twinkle-dot"
            style={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              background: '#4ade80',
              boxShadow: '0 0 10px rgba(74,222,128,0.7)',
              display: 'block',
            }}
          />
          <span>Tous syst&egrave;mes op&eacute;rationnels</span>
        </div>

        {/* Baseline */}
        <div className="absolute z-[3]" style={{ top: '50%', left: '8%', right: '8%', transform: 'translateY(-50%)', maxWidth: 760 }}>
          <h2 style={{
            fontFamily: "'Geist', sans-serif",
            fontWeight: 800,
            fontSize: 'clamp(44px, 5.4vw, 70px)',
            lineHeight: 1.02,
            letterSpacing: '-0.045em',
            margin: 0,
            color: '#fff',
            textShadow: '0 2px 40px rgba(0,0,0,0.4)',
          }}>
            Votre SEO{'\u00A0'}
            <br />
            <span style={{
              background: 'linear-gradient(100deg, #b5e8ff 0%, #d7b8ff 50%, #ffc6eb 100%)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
            }}>
              d'un seul coup d'oeil
            </span>
          </h2>
          <p style={{
            marginTop: 28,
            fontFamily: "'Geist', sans-serif",
            fontSize: 16,
            lineHeight: 1.55,
            color: 'rgba(234,238,251,0.72)',
            maxWidth: 460,
            fontWeight: 400,
          }}>
            Audits techniques, suivi de positions et visibilit&eacute; sur les moteurs de recherche et les LLM.
          </p>
        </div>

        {/* Coordinate chip */}
        <div className="absolute bottom-8 right-9 z-[4] text-right" style={{
          fontFamily: "'Geist Mono', monospace",
          fontSize: 11,
          color: 'rgba(234,238,251,0.45)',
          lineHeight: 1.6,
          letterSpacing: '0.08em',
        }}>
          <div><span style={{ color: 'rgba(234,238,251,0.3)' }}>RA</span> 05h 35m 17.3s</div>
          <div><span style={{ color: 'rgba(234,238,251,0.3)' }}>DEC</span> &minus;05&deg; 23&prime; 28&Prime;</div>
          <div><span style={{ color: 'rgba(234,238,251,0.3)' }}>M42</span> &middot; Orion Nebula</div>
        </div>
      </section>
    </div>
  )
}
